function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.879 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M231.385.192A.649.649,0,0,0,230.869,0l-5.028.458a.647.647,0,0,0-.4,1.1l1.372,1.372L219.957,9.79a.647.647,0,0,0,0,.914l.914.914a.647.647,0,0,0,.915,0l6.856-6.856,1.372,1.372a.65.65,0,0,0,.677.151.657.657,0,0,0,.237-.151.639.639,0,0,0,.186-.4l.458-5.028A.649.649,0,0,0,231.385.192Z",
  transform: "translate(-219.768 -0.002)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1,7.757V18.1H2.586V2.586H12.929V0H1.293A1.292,1.292,0,0,0,0,1.293v18.1a1.293,1.293,0,0,0,1.293,1.293h18.1a1.293,1.293,0,0,0,1.293-1.293V7.757Z"
});

function SvgExternalLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.686,
    height: 20.686,
    viewBox: "0 0 20.686 20.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.d3ed1db4.svg";
export { ForwardRef as ReactComponent };